import { X, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@hipotecar/ui/card";
import { Button } from "@hipotecar/ui/button";
import astrunatGirlSrc from "@/assets/illustrations/empty-states/astrunat-girl.png";

interface EntitlementGateCardProps {
	title: string;
	description: string;
	cta: string;
	showIllustration?: boolean;
	onClose?: () => void;
	/** Where the CTA goes. Defaults to the pricing page. */
	ctaHref?: string;
	/** Called just before navigating, e.g. to record the click. */
	onCtaClick?: () => void;
	/** Stable selector for analytics (PostHog `data-attr`). */
	ctaDataAttr?: string;
}

export default function EntitlementGateCard({
	title,
	description,
	cta,
	showIllustration = true,
	onClose,
	ctaHref = "/pricing",
	onCtaClick,
	ctaDataAttr,
}: EntitlementGateCardProps) {
	return (
		<Card className="mx-auto max-w-[420px] overflow-hidden border border-slate-200 bg-white text-slate-950 shadow-2xl dark:border-[#28324f] dark:bg-[#151d33] dark:text-white">
			<CardContent className="relative flex flex-col items-center p-6 text-center">
				{onClose ? (
					<button
						type="button"
						onClick={onClose}
						className="absolute top-5 right-5 text-slate-500 transition-colors hover:text-slate-900 dark:text-white/70 dark:hover:text-white"
						aria-label="Close"
					>
						<X className="size-5" />
					</button>
				) : (
					<div className="absolute top-5 right-5 text-slate-500 dark:text-white/70">
						<X className="size-5" />
					</div>
				)}
				<h2 className="mt-2 mb-6 px-4 text-2xl font-extrabold tracking-tight text-slate-950 sm:text-3xl dark:text-white">
					{title}
				</h2>
				{showIllustration && (
					<div className="relative mb-6 aspect-square w-full max-w-[320px] overflow-hidden rounded-[28px] bg-[#151d33]">
						<div className="absolute inset-0 flex items-center justify-center">
							<img
								src={astrunatGirlSrc}
								alt=""
								className="pointer-events-none h-[90%] w-auto max-w-none object-contain"
							/>
						</div>
					</div>
				)}
				<div className="mb-8 space-y-3">
					<p className="mx-auto max-w-[280px] text-sm/6 text-slate-600 dark:text-slate-300">
						{description}
					</p>
				</div>
				<Button
					data-attr={ctaDataAttr}
					onClick={() => {
						onCtaClick?.();
						window.location.href = ctaHref;
					}}
					className="w-full gap-2"
				>
					{cta}
					<ChevronRight className="size-5" />
				</Button>
			</CardContent>
		</Card>
	);
}
